module.exports = __webpack_public_path__ + "static/img/character-cancer.31582672.png";